import React from "react";
import { Badge } from "react-bootstrap";

/**
 * TASK-19 · Shows how many grade-card batches are queued for sync.
 * Hidden when the queue is empty.
 */
function SyncStatus({ count = 0 }) {
  if (!count) return null;
  return (
    <Badge bg="warning" text="dark" aria-live="polite">
      ● {count} pendiente{count > 1 ? "s" : ""} de sincronizar
    </Badge>
  );
}

export { SyncStatus };
